const config = {
    // basename: only at build time to set, and don't add '/' at end off BASENAME for breadcrumbs, also don't put only '/' use blank('') instead,
    // like '/berry-material-react/react/default'
    basename: '',
    defaultPath: '/dashboard',
    fontFamily: `'Space Grotesk', sans-serif`,
    borderRadius: 6,
    // API_SERVER:  'http://localhost:5000/',
    // API_SERVER: 'https://backend-dot-quantle.ue.r.appspot.com/',
    API_SERVER:  'https://quantle.eshci.com/api/',
    MARKETPLACE_API: "https://bots.surmount.ai/"
};

export default config;
